<div class="sample-collection-metrics-widget">
  <div class="widget-title-header">
    @if (widgetTitle) {
      <span class="widget-title">{{ titleMeta.isCustom ? widgetTitle : (widgetTitle | translate) }}{{ titleMeta.tailPrefix }}{{ titleMeta.tailKey | translate }}{{ titleMeta.tail }}</span>
    }
    <span class="widget-subtitle">{{ 'Sample collection volume and year-over-year trend analysis' | translate }}</span>
  </div>
  <hr class="widget-divider">

  <div class="filters-wrapper">
    <app-sample-collection-metrics-filters
      mode="inline"
      [values]="filterValues"
      (filterChange)="onFilterValuesChange($event)"
      (filterReconcile)="onFilterValuesReconcile($event)">
      <app-widget-org-filter filterAppend
        [orgLevelId]="orgLevelOverrideId"
        (orgLevelIdChange)="onOrgLevelOverrideChange($event)">
      </app-widget-org-filter>
    </app-sample-collection-metrics-filters>
  </div>

  <div class="widget-content">
    @if (isLoading) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
      </div>
    }

    @if (error && !isLoading) {
      <div class="error-container">
        <i class="material-icons">error_outline</i>
        <span>{{ error }}</span>
      </div>
    }

    @if (!isLoading && !error && data && kpiVm) {
      <div class="kpi-row">
        <div class="kpi-card kpi-total">
          <div class="kpi-value">{{ data.kpi.totalCollected }}</div>
          <div class="kpi-label">{{ 'Total Collected' | translate }}</div>
          <div class="kpi-trend" [ngClass]="kpiVm.trendClass">
            <i class="material-icons trend-icon">{{ kpiVm.trendIcon }}</i>
            <span>{{ kpiVm.formattedYoy }} {{ 'YoY' | translate }}</span>
          </div>
        </div>
        <div class="kpi-card kpi-personal">
          <div class="kpi-value">{{ data.kpi.personalCount }}</div>
          <div class="kpi-label">{{ 'Personal' | translate }}</div>
        </div>
        <div class="kpi-card kpi-area">
          <div class="kpi-value">{{ data.kpi.areaCount }}</div>
          <div class="kpi-label">{{ 'Area' | translate }}</div>
        </div>
      </div>
      <div class="chart-container">
        <div class="section-label">{{ 'Collection Trend' | translate }}</div>
        <div #chartDiv class="chart-area"></div>
      </div>
      @if (pivotRows.length > 0) {
        <div class="breakdown-table-container">
          <div class="section-label">{{ 'Year-over-Year by' | translate }} {{ stackByLabel | translate }}</div>
          <div class="pivot-table-wrapper">
            <table class="breakdown-table pivot-table">
              <thead>
                <ng-template #sortIcon let-column>
                  @if (sort.column === column) {
                    <i class="material-icons sort-icon">{{ sort.ascending ? 'arrow_upward' : 'arrow_downward' }}</i>
                  }
                </ng-template>
                <tr>
                  <th class="sticky-col sortable" (click)="sortBy(sortColumns.Name)">
                    {{ stackByLabel | translate }}
                    <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: sortColumns.Name }"></ng-container>
                  </th>
                  @for (period of pivotPeriods; track trackByIndex($index)) {
                    <th class="text-center sortable" (click)="sortBy(period)">
                      {{ period }}
                      <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: period }"></ng-container>
                    </th>
                  }
                  <th class="text-center sortable" (click)="sortBy(sortColumns.Total)">
                    {{ 'Total' | translate }}
                    <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: sortColumns.Total }"></ng-container>
                  </th>
                  <th class="text-center sortable" (click)="sortBy(sortColumns.YoyChangePercent)">
                    {{ 'YoY' | translate }}
                    <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: sortColumns.YoyChangePercent }"></ng-container>
                  </th>
                  @if (isStackBySeg) {
                    <th class="text-center">{{ 'Employees' | translate }}</th>
                    <th class="text-center">{{ 'Contractors' | translate }}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of pivotRows; track trackByItemId($index, row)) {
                  <tr>
                    <td class="item-name sticky-col"><strong>{{ row.name }}</strong></td>
                    @for (period of pivotPeriods; track trackByIndex($index)) {
                      <td class="text-center">
                        {{ row.periodTotals[period] ?? 0 }}
                      </td>
                    }
                    <td class="text-center current-value"><strong>{{ row.total }}</strong></td>
                    <td class="text-center yoy-change" [ngClass]="row.trendClass">
                      {{ row.formattedYoy }}
                    </td>
                    @if (isStackBySeg) {
                      <td class="text-center">{{ row.workerCount ?? '—' }}</td>
                      <td class="text-center">{{ row.contractorCount ?? '—' }}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      @if (data.timeSeries.length === 0 && pivotRows.length === 0) {
        <div class="no-data">
          <i class="material-icons">info_outline</i>
          <span>{{ 'No sample collection data found for the selected filters' | translate }}</span>
        </div>
      }
    }
  </div>
</div>
